import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { dns } from 'src/app/global.config';
import { DateInterval } from 'src/app/shared/model';
import { createAuthorizationHeader } from 'src/app/utils/security/headers';
import { FuelingClassification, TravelReport } from '../../parc-management';
import { ActivityVehiculeClassification, VehiculeClassification } from './activity-vehicule-classifications.model';
import { DriverScore } from './activity-vehicle-classification.component';

@Injectable()
export class ActivityVehiculeClassificationsService {

  constructor(private http: HttpClient) { }

  save(payload: ActivityVehiculeClassification): Observable<ActivityVehiculeClassification> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<ActivityVehiculeClassification>(dns + "coefficient-settings", payload, options);
  }

  getCoefficicientSettingsByGroupId(groupId : number): Observable<ActivityVehiculeClassification> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.get<ActivityVehiculeClassification>(dns + "coefficient-settings/" + groupId + "/group", options);
  }

  getVehicleActivityClassificationByTransportTypeIdOrGroupId(id: number, date: DateInterval, type: string): Observable<TravelReport[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<TravelReport[]>(dns + 'activities/classification/' + id + '?timeZoneOfeset=' + (new Date().getTimezoneOffset()) + '&type=' + type, date, options);
  }

  getVehicleTurnOverClassificationsByGroupId(id: number, date: DateInterval): Observable<VehiculeClassification[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<VehiculeClassification[]>(dns + 'driverCharges/classification/' + id, date, options);
  }

  getVehicleFuelingClassificationByTransportTypeId(transportTypeId: number, date: DateInterval, type: string): Observable<FuelingClassification[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<FuelingClassification[]>(dns + 'fuelings/classification/' + transportTypeId + '?type=' + type, date, options);
  }

  getVehicleLossesClassificationsByGroupId(type: string, groupId: number, date: DateInterval): Observable<VehiculeClassification[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<VehiculeClassification[]>(dns + type + '/classification/' + groupId, date, options);
  }

  getSpeedCartoClassificationsByTransportTypeId(transportTypeId: number, date: DateInterval, type: string): Observable<VehiculeClassification[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<VehiculeClassification[]>(dns + 'alerts/notifications/classification/' + transportTypeId + '?type=' + type, date, options);
  }

  getVehicleRotationClassificationByTransportTypeId(transportTypeId: number, date: DateInterval, type: string): Observable<TravelReport[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<TravelReport[]>(dns + 'paths/classification/' + transportTypeId + '?type=' + type, date, options);
  }

  topFiveVehicules(values: any[], coefficient: number, ratings: any[], isMatricule: boolean): any[] {

    var topFiveActivities = values.slice(0, 5);
    let mark = 10;
    for (let topFive of topFiveActivities) {
      topFive.mark = mark * coefficient;
      let note = topFive.mark

      var rate = [];
      let matricule;
      let driver;

      if (isMatricule) {
        rate = ratings.filter(r => r.matricule == topFive.matricule);
        matricule = topFive.matricule;
        driver = topFive.driver;
      } else {
        rate = ratings.filter(r => r.matricule == topFive.vehiculeMatricule);
        matricule = topFive.vehiculeMatricule;
        driver = topFive.driverFullName;
      }

      if (rate.length > 0) {
        rate[0].note += note;
      } else {
        ratings.push({
          matricule: matricule,
          driver: driver,
          avatarUri: topFive.avatarUri,
          note: topFive.mark
        });
      }
      mark--;
    }
    return ratings;
  }

  offenseAndSinistreRating(values: any[], coefficient: number, ratings: any[]): any[] {

    let mark = -10;
    for (let vl of values) {
      if (vl.cost == 0)
        vl.mark = 10 * coefficient;
      else {
        vl.mark = mark * coefficient;
        mark--;
      }
      let note = vl.mark


      var rate = [];
      let matricule;
      let driver;

      rate = ratings.filter(r => r.matricule == vl.matricule);
      matricule = vl.matricule;
      driver = vl.driver;

      if (rate.length > 0) {
        rate[0].note += note;
      } else {
        ratings.push({
          matricule: matricule,
          driver: driver,
          avatarUri: vl.avatarUri,
          note: vl.mark
        });
      }

    }
    return ratings;
  }


computeDriverScores(
  kmArray: any[],
  fuelingArray: any[],
  sinistreArray: any[],
  turnOverArray: any[],
  offenseArray:any[],
  activityArray:any[],
  pathTimeArray:any[],
  coefficients: { coefficientMileage: number; coefficientFueling: number; coefficientSinistre: number; coefficientTurnover: number ,coefficientOffense:number,coefficientWorkingTime:number,coefficientHactivity:number}
): DriverScore[] {
  const ratingsMap: Record<string, DriverScore> = {};

  function processArray(array: any[], key: string, coefficient: number,higherOrLower:boolean) {
    const values = array.map(v => v[key]).filter(v => v != null && !isNaN(v));
    const min = Math.min(...values);
    const max = Math.max(...values);

    if(key === 'pathTime'){console.log("this path time ",array)}
    for (let item of array) {
      const normalized = normalizeTo10(item[key], min, max,higherOrLower) * coefficient;
      const mapKey = key ==='distanceDriven' || key === 'pathTime' || key === 'pathDuration' ? item.driverFullName : item.driver
      if (!ratingsMap[mapKey]) {
        ratingsMap[mapKey] = {
          matricule: key === 'distanceDriven' || key === 'pathTime' || key === 'pathDuration' ? item.vehiculeMatricule :item.matricule,
          driver: key === 'distanceDriven' || key === 'pathTime' || key === 'pathDuration' ? item.driverFullName : item.driver,
          avatarUri: item.avatarUri,
          score: 0
        };
      }

      ratingsMap[mapKey].score += normalized;
      if(key === 'pathTime'){console.log("this path time normalized",normalized)}
    }
  }

  function normalizeTo10(value: number, min: number, max: number,higherOrLower:boolean): number {
    if (max === min) return 5;
    const normalized = ((value - min) / (max - min)) * 9 + 1;
    return higherOrLower ? normalized : 10 - normalized ;
  }

  if(kmArray && kmArray.length){processArray(kmArray, 'distanceDriven', coefficients.coefficientMileage,true);}
  if(turnOverArray && turnOverArray.length){processArray(turnOverArray, 'total', coefficients.coefficientTurnover,true);}
  if(pathTimeArray && pathTimeArray.length){processArray(pathTimeArray, 'pathTime', coefficients.coefficientWorkingTime,true);}
  if(activityArray && activityArray.length){processArray(activityArray, 'pathDuration', coefficients.coefficientHactivity,true);}

  if(sinistreArray && sinistreArray.length){
    const base = this.getBaseArray(kmArray, turnOverArray, pathTimeArray, activityArray,fuelingArray);
    if(base.length){sinistreArray = this.fillMissingDrivers(base,sinistreArray,'total')}
    processArray(sinistreArray, 'total', coefficients.coefficientSinistre,false);
  }

  if(offenseArray && offenseArray.length){
    const base = this.getBaseArray(kmArray, turnOverArray, pathTimeArray, activityArray,fuelingArray);
    if(base.length){offenseArray = this.fillMissingDrivers(base,offenseArray,'total')}
    processArray(offenseArray, 'total', coefficients.coefficientOffense,false);
  }

  if(fuelingArray && fuelingArray.length){
    const base = this.getBaseArray(kmArray, turnOverArray, pathTimeArray, activityArray,fuelingArray);
    if(base.length){fuelingArray = this.fillMissingDrivers(base,fuelingArray,'total')}
    processArray(fuelingArray, 'cost', coefficients.coefficientFueling,false);
  }

  // Convert map to array and sort by score descending
  return Object.values(ratingsMap).sort((a, b) => b.score - a.score).slice(0, 5);
}

fillMissingDrivers(baseDrivers: any[], metricArray: any[], key: string) {
  if (!baseDrivers || baseDrivers.length === 0) return metricArray;
  const existingDrivers = new Set(metricArray.map(m => m.driver));
  const filledArray = [...metricArray];
  const sample = baseDrivers[0];
  const driverKey = sample.driverFullName ? 'driverFullName' : 'driver';
  const vehicleKey = sample.vehiculeMatricule ? 'vehiculeMatricule' : 'matricule';

  for (const d of baseDrivers) {
    if (!existingDrivers.has(d[driverKey])) {
      filledArray.push({
        matricule: d[vehicleKey],
        driver: d[driverKey],
        avatarUri: d.avatarUri,
        [key]: 0
      });
    }
  }

  return filledArray;
}

getBaseArray(kmArray: any[],turnOverArray: any[],pathTimeArray: any[],activityArray: any[],fuelingArray:any[]) {
  const arrays = [kmArray,fuelingArray, turnOverArray, pathTimeArray, activityArray];
  for (const arr of arrays) {
    if (arr && arr.length > 0) {
      return arr;
    }
  }
  return [];
}

getColorFromName(name: string): string {
  const hash = Array.from(name)
    .reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const color = (hash & 0x00FFFFFF).toString(16).toUpperCase();
  return "#" + "000000".substring(0, 6 - color.length) + color;
}


}
